export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14756.a0187568.jpg";